<template>
  <div class="about-us">
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper hero-section about-page-hero"
         v-show="!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showHero"
                 v-model="content.heroSection.hideSection" />
          <label :for="'showHero'">Hide this section</label>
        </div>
        <div class="flex-section">
          <div class="left-content background-1-20-before">
            <div class="hero-title background-1-50-before background-1-100-after">
              <h1 class="content color-1-100"
                  v-html="content.heroSection.title"
                  v-if="!pageEditMode">
              </h1>
              <textarea class="content color-1-100"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.title"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
            </div>
            <div class="hero-description background-1-10-before">
              <span class="content color-2-77"
                    :inner-html.prop="content.heroSection.description | nl2br"
                    v-if="!pageEditMode">
              </span>
              <textarea class="content color-2-77"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.description"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.description }}</textarea>
            </div>
            <div class="hero-button" :class="pageEditMode ? 'edit-mode' : ''">
              <template v-if="pageEditMode">
                <div class="form-group">
                  <div class="form-element form-element--half">
                    <label for="page-versions" class="form-label color-2-63">Button text</label>
                    <input type="text"
                           class="form-control form-control__input"
                           v-model="content.heroSection.button.text" placeholder="Button text" />
                  </div>
                  <div class="form-element form-element--half">
                    <label for="page-versions" class="form-label color-2-63">Button link</label>
                    <input type="text"
                           class="form-control form-control__input"
                           v-model="content.heroSection.button.link" placeholder="Button link" />
                  </div>
                </div>
              </template>
              <template v-else>
                <a :href="content.heroSection.button.link">{{ content.heroSection.button.text }}</a>
              </template>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="right-content">
            <div class="hero-image hero-image__about background-1-10-after background-2-4-before">
              <div class="content"
                   :title="content.heroSection.altImage"
                   v-bind:style="{ backgroundImage: getImage(content.heroSection.image) }">
                <input type="text"
                       placeholder="Alt image"
                       v-if="pageEditMode && isGM()"
                       class="landing-page-image-alt"
                       v-model="content.heroSection.altImage" />
                <label :for="'hero-image-upload'"
                       v-if="pageEditMode && isGM()"
                       class="hero-upload"></label>
                <input type="file"
                       v-if="pageEditMode && isGM()"
                       @change="onFileChange($event, content.heroSection, 'image')"
                       :id="'hero-image-upload'" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper how-it-works-section about-page-section landing-page-wrapper__gray"
         role="region"
         aria-labelledby="howItWorksTitle"
         v-show="!content.howItWorksSection.hideSection || content.howItWorksSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showhowItWorksSection"
                 v-model="content.howItWorksSection.hideSection" />
          <label :for="'showhowItWorksSection'">Hide this section</label>
        </div>
        <div class="section-container">
          <h2 class="section-title"
              id="howItWorksTitle"
              v-html="content.howItWorksSection.title"
              v-if="!pageEditMode && content.howItWorksSection.title !== ''"></h2>
          <textarea class="section-title"
                    v-if="pageEditMode && isGM()"
                    data-gramm_editor="false"
                    placeholder="Section title"
                    data-lpignore="true"
                    rows="1"
                    v-model="content.howItWorksSection.title"
                    v-on:keydown="autoSize($event)"></textarea>
          <div class="section-description"
               :inner-html.prop="content.howItWorksSection.description | nl2br"
               v-if="!pageEditMode && content.howItWorksSection.description !== ''"></div>
          <textarea class="section-description"
                    v-if="pageEditMode && isGM()"
                    data-gramm_editor="false"
                    placeholder="Description"
                    data-lpignore="true"
                    rows="1"
                    v-model="content.howItWorksSection.description"
                    v-on:keydown="autoSize($event)"></textarea>
          <div class="list flex-section" v-if="!getDeviceType('mobile')">
            <div class="list-item"
                 v-for="(item, index) in content.howItWorksSection.sections">
              <div class="landing-page-remove"
                   v-if="pageEditMode && isGM()"
                   @click.prevent="removeSection(content.howItWorksSection.sections, index)"></div>
              <div class="list-item-icon">
                <div class="content"
                     :title="getHighImageAlt(item)"
                     v-bind:style="{ backgroundImage: getImage(getHighImage(item)) }">
                <span class="landing-page-image-upload"
                      @click.prevent.stop="activatePopup(item)"
                      v-if="pageEditMode && isGM()"></span>
                </div>
              </div>
              <div class="list-item-title">
                <div class="content"
                     v-html="item.title"
                     v-if="!pageEditMode"></div>
                <textarea class="content"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Title"
                          data-lpignore="true"
                          rows="1"
                          v-model="item.title"
                          v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
              </div>
              <div class="list-item-description">
                <div class="content"
                     :inner-html.prop="item.text | nl2br"
                     v-if="!pageEditMode"></div>
                <textarea class="content"
                          v-if="pageEditMode && isGM()"
                          data-gramm_editor="false"
                          placeholder="Description"
                          data-lpignore="true"
                          rows="1"
                          v-model="item.text"
                          v-on:keydown="autoSize($event)">{{ item.text }}</textarea>
              </div>
            </div>
          </div>
          <div class="content-slider" v-if="getDeviceType('mobile')">
            <slick class="slider"
                   ref="howItWorksSlick"
                   v-if="slidesReady"
                   :options="howItWorksOptionsContent">
              <div class="list-item" v-for="item in content.howItWorksSection.sections">
                <div class="list-item-icon">
                  <div class="content"
                       :title="getHighImageAlt(item)"
                       v-bind:style="{ backgroundImage: getImage(getHighImage(item)) }">
                <span class="landing-page-image-upload"
                      @click.prevent.stop="activatePopup(item)"
                      v-if="pageEditMode && isGM()"></span>
                  </div>
                </div>
                <div class="list-item-title">
                  <div class="content"
                       v-html="item.title"
                       v-if="!pageEditMode"></div>
                  <textarea class="content"
                            v-if="pageEditMode && isGM()"
                            data-gramm_editor="false"
                            placeholder="Title"
                            data-lpignore="true"
                            rows="1"
                            v-model="item.title"
                            v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
                </div>
                <div class="list-item-description">
                  <div class="content"
                       :inner-html.prop="item.text | nl2br"
                       v-if="!pageEditMode"></div>
                  <textarea class="content"
                            v-if="pageEditMode && isGM()"
                            data-gramm_editor="false"
                            placeholder="Description"
                            data-lpignore="true"
                            rows="1"
                            v-model="item.text"
                            v-on:keydown="autoSize($event)">{{ item.text }}</textarea>
                </div>
              </div>
            </slick>
          </div>
          <div class="landing-page-add-section"
               @click.prevent="addSection('how-it-works')"
               v-if="pageEditMode && isGM()">+ Add row</div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper subscribe-section about-page landing-page-wrapper__gray"
         v-show="!content.subscribeSection.hideSection || content.subscribeSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showSubscribe"
                 v-model="content.subscribeSection.hideSection" />
          <label for="showSubscribe">Hide this section</label>
        </div>
        <div class="flex-section">
          <div class="left-section">
            <h2 class="section-title"
                v-html="content.subscribeSection.title"
                v-if="!pageEditMode"></h2>
            <textarea class="section-title"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Section title"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.subscribeSection.title"
                      v-on:keydown="autoSize($event)">{{ content.subscribeSection.title }}</textarea>
            <div class="section-description"
                 :inner-html.prop="content.subscribeSection.description | nl2br"
                 v-if="!pageEditMode"></div>
            <textarea class="section-description"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Description"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.subscribeSection.description"
                      v-on:keydown="autoSize($event)">{{ content.subscribeSection.description }}</textarea>
          </div>
          <div class="right-section">
            <form class="tcc-form" @submit.stop.prevent="subscribeMe()">
              <h3 class="section-subtitle"
                  v-html="content.subscribeSection.formTitle"
                  v-if="!pageEditMode"></h3>
              <textarea class="section-subtitle"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Form title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.subscribeSection.formTitle"
                        v-on:keydown="autoSize($event)"></textarea>
              <div class="tcc-form-group">
                <label for="tcc-form-firstname" class="tcc-form-element tcc-form-element__label">First name*</label>
                <input id="tcc-form-firstname"
                       class="tcc-form-element tcc-form-element__input light"
                       :class="[{ 'border-1-50': subscribeForm.firstname !== '' || subscribeForm.firstnameFocus, 'not-empty': subscribeForm.firstname !== '' || subscribeForm.firstnameFocus, 'has-error': this.errors.has('First name') }]"
                       type="text"
                       name="First name"
                       data-vv-name="First name"
                       v-validate="'required'"
                       placeholder="Type in here..."
                       @focus="subscribeForm.firstnameFocus = true"
                       @blur="subscribeForm.firstnameFocus = false"
                       v-model="subscribeForm.firstname" />
                <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
              </div>
              <div class="tcc-form-group">
                <label for="tcc-form-lastname" class="tcc-form-element tcc-form-element__label">Last name*</label>
                <input id="tcc-form-lastname"
                       class="tcc-form-element tcc-form-element__input light"
                       :class="[{ 'border-1-50': subscribeForm.lastname !== '' || subscribeForm.lastnameFocus, 'not-empty': subscribeForm.lastname !== '' || subscribeForm.lastnameFocus, 'has-error': this.errors.has('Last name') }]"
                       type="text"
                       name="Last name"
                       data-vv-name="Last name"
                       v-validate="'required'"
                       placeholder="Type in here..."
                       @focus="subscribeForm.lastnameFocus = true"
                       @blur="subscribeForm.lastnameFocus = false"
                       v-model="subscribeForm.lastname" />
                <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
              </div>
              <div class="tcc-form-group">
                <label for="tcc-form-email" class="tcc-form-element tcc-form-element__label">Email address*</label>
                <input id="tcc-form-email"
                       class="tcc-form-element tcc-form-element__input light"
                       :class="[{ 'border-1-50': subscribeForm.email !== '' || subscribeForm.emailFocus, 'not-empty': subscribeForm.email !== '' || subscribeForm.emailFocus, 'has-error': this.errors.has('Email address') }]"
                       type="email"
                       name="Email address"
                       data-vv-name="Email address"
                       v-validate="'required|email'"
                       placeholder="Type in here..."
                       @focus="subscribeForm.emailFocus = true"
                       @blur="subscribeForm.emailFocus = false"
                       v-model="subscribeForm.email" />
                <span class="form-field-error" v-if="this.errors.has('Email address')">{{ this.errors.first('Email address') }}</span>
              </div>
              <div class="tcc-form-actions">
                <button name="subscribe"
                        type="submit"
                        class="tcc-form-action background-1-20 background-1-60-hover">Subscribe</button>
              </div>
              <div class="tcc-form-message"
                   aria-live="assertive">
                <div v-if="this.formStatus.submitting" class="visually-hidden">
                  Submitting
                </div>
                <template v-else>
                  <template v-if="formStatus.shown">
                    <h2 v-if="formStatus.title !== ''">
                      <template v-if="formStatus.success">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-envelope" class="svg-inline--fa fa-circle-envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM384 320c0 17.67-14.33 32-32 32H160c-17.67 0-32-14.33-32-32V238l122.1 48.82C251.1 287.6 253.1 288 256 288s4.031-.375 5.938-1.141L384 238V320zM384 203.6l-128 51.2L128 203.6V192c0-17.67 14.33-32 32-32h192c17.67 0 32 14.33 32 32V203.6z"></path>
                        </svg>
                      </template>
                      <template v-else>
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-xmark" class="svg-inline--fa fa-circle-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"></path>
                        </svg>
                      </template>
                      {{ formStatus.title }}
                    </h2>
                    <p v-if="formStatus.body !== ''">
                      {{ formStatus.body }}
                    </p>
                  </template>
                  <template v-else-if="this.errors.items && this.errors.items.length">
                    <h2>
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" class="svg-inline--fa fa-circle-exclamation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"></path>
                      </svg>
                      Some fields are missing.
                    </h2>
                    <p>Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.</p>
                  </template>
                </template>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="landing-page-wrapper clients-section about-page"
         v-show="!content.clientSection.hideSection || content.clientSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showClient"
                 v-model="content.clientSection.hideSection" />
          <label for="showClient">Hide this section</label>
        </div>
        <div class="section-title">
          <h2 class="content"
              v-html="content.clientSection.title"
              v-if="!pageEditMode && content.clientSection.title && content.clientSection.title !== ''"></h2>
          <textarea class="content"
                    v-if="pageEditMode && isGM()"
                    data-gramm_editor="false"
                    placeholder="Section title"
                    data-lpignore="true"
                    rows="1"
                    v-model="content.clientSection.title"
                    v-on:keydown="autoSize($event)"></textarea>
        </div>
        <div class="section-description">
          <div class="content"
               :inner-html.prop="content.clientSection.description | nl2br"
               v-if="!pageEditMode && content.clientSection.description && content.clientSection.description !== ''"></div>
          <textarea class="content"
                    v-if="pageEditMode && isGM()"
                    data-gramm_editor="false"
                    placeholder="Section description"
                    data-lpignore="true"
                    rows="1"
                    v-model="content.clientSection.description"
                    v-on:keydown="autoSize($event)"></textarea>
        </div>
        <div class="logos">
          <div class="clients-slider">
            <a v-for="item in content.clientSection.logos"
               :href="item.url">
              <img :src="getImageFullPath(item.image)"
                   :alt="item.altImage">
            </a>
          </div>
          <div class="landing-page-slider-change"
               @click.prevent.stop="switchSliderModal()"
               v-if="pageEditMode"></div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper testimonials-section landing-page-wrapper__gray"
         id="our-clients"
         role="region"
         aria-labelledby="testimonialsTitle"
         v-show="!content.testimonialsSection.hideSection || content.testimonialsSection.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showTestimonialsSection"
                 v-model="content.testimonialsSection.hideSection" />
          <label :for="'showTestimonialsSection'">Hide this section</label>
        </div>
        <div class="section-container">
          <h2 class="section-title center"
              id="testimonialsTitle"
              v-html="content.testimonialsSection.title"
              v-if="!pageEditMode"></h2>
          <textarea class="section-title center"
                    v-if="pageEditMode && isGM()"
                    data-gramm_editor="false"
                    placeholder="Section title"
                    data-lpignore="true"
                    rows="1"
                    v-model="content.testimonialsSection.title"
                    v-on:keydown="autoSize($event)">{{ content.testimonialsSection.title }}</textarea>
          <div class="list">
            <div class="list-item edit-mode"
                 v-if="pageEditMode"
                 :key="index"
                 v-for="(item, index) in content.testimonialsSection.testimonials">
              <div class="landing-page-remove"
                   v-if="pageEditMode && isGM()"
                   @click.prevent="removeSection(content.testimonialsSection.testimonials, index)"></div>
              <div class="list-item-content">
                <div class="list-item-text">
                  <textarea class="content"
                            v-if="isGM()"
                            data-gramm_editor="false"
                            placeholder="Text"
                            data-lpignore="true"
                            rows="1"
                            v-model="item.text"
                            v-on:keydown="autoSize($event)">{{ item.text }}</textarea>
                </div>
                <div class="list-item-image">
                  <div class="landing-page-remove"
                       v-if="pageEditMode && isGM()"
                       @click.prevent="item.image = null"></div>
                  <div class="content"
                       v-bind:style="{ backgroundImage: getImage(item.image) }">
                    <label :for="'testimonial-image-upload-' + index"
                           v-if="isGM()"
                           class="list-item-image-upload"></label>
                    <input type="file"
                           v-if="isGM()"
                           @change="onFileChange($event, item, 'image')"
                           :id="'testimonial-image-upload-' + index" />
                  </div>
                </div>
                <div class="list-item-meta">
                  <div class="list-item-meta-name">
                    <textarea class="content"
                              v-if="isGM()"
                              data-gramm_editor="false"
                              placeholder="Name"
                              data-lpignore="true"
                              rows="1"
                              v-model="item.name"
                              v-on:keydown="autoSize($event)">{{ item.name }}</textarea>
                  </div>
                  <div class="list-item-meta-company">
                    <textarea class="content"
                              v-if="isGM()"
                              data-gramm_editor="false"
                              placeholder="Company"
                              data-lpignore="true"
                              rows="1"
                              v-model="item.company"
                              v-on:keydown="autoSize($event)">{{ item.company }}</textarea>
                  </div>
                </div>
              </div>
            </div>
            <slick class="slider"
                   ref="testimonialsSlick"
                   v-if="!pageEditMode && slidesReady"
                   :options="testimonialsOptionsContent">
              <div class="list-item"
                   :key="index"
                   v-for="(item, index) in content.testimonialsSection.testimonials">
                <div class="list-item-content">
                  <div class="list-item-text">
                    <div class="content"
                         :inner-html.prop="item.text | nl2br"></div>
                  </div>
                  <div class="list-item-image">
                    <div class="content" v-bind:style="{ backgroundImage: getImage(item.image) }">
                    </div>
                  </div>
                  <div class="list-item-meta">
                    <div class="content">
                      <span v-html="item.name"></span> | <span v-html="item.company"></span>
                    </div>
                  </div>
                </div>
              </div>
            </slick>
            <div class="landing-page-add-section"
                 @click.prevent="addSection('testimonials')"
                 v-if="pageEditMode && isGM()">+ Add row</div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-wrapper contact-cta-section"
         role="region"
         aria-labelledby="contactCTATitle"
         v-show="!content.contactCTA.hideSection || content.contactCTA.hideSection === 'null' || (pageEditMode && isGM())">
      <div class="landing-page-content">
        <div class="toggle-section-visibility"
             v-if="pageEditMode && isGM()">
          <input type="checkbox"
                 class="form-control__checkbox"
                 id="showContactCTASection"
                 v-model="content.contactCTA.hideSection" />
          <label :for="'showContactCTASection'">Hide this section</label>
        </div>
      </div>
      <div class="contact-cta">
        <div class="contact-cta--content">
          <div class="contact-cta--content__title">
            <h1 class="content"
                v-html="content.contactCTA.title"
                v-if="!pageEditMode"></h1>
            <textarea class="content"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Title"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.contactCTA.title"
                      v-on:keydown="autoSize($event)">{{ content.contactCTA.title }}</textarea>
          </div>
          <div class="contact-cta--content__text">
            <p class="content"
               v-html="content.contactCTA.text"
               v-if="!pageEditMode"></p>
            <textarea class="content"
                      v-if="pageEditMode && isGM()"
                      data-gramm_editor="false"
                      placeholder="Text"
                      data-lpignore="true"
                      rows="1"
                      v-model="content.contactCTA.text"
                      v-on:keydown="autoSize($event)">{{ content.contactCTA.text }}</textarea>
          </div>
          <div class="contact-cta--actions" :class="pageEditMode ? 'edit-mode' : ''">
            <template v-for="button in content.contactCTA.buttons">
              <template v-if="pageEditMode">
                <div class="form-group">
                  <div class="form-element form-element--half">
                    <label for="page-versions" class="form-label color-2-63">Button text</label>
                    <input type="text"
                           class="form-control form-control__input"
                           v-model="button.text" placeholder="Button text" />
                  </div>
                  <div class="form-element form-element--half">
                    <label for="page-versions" class="form-label color-2-63">Button link</label>
                    <input type="text"
                           class="form-control form-control__input"
                           v-model="button.link" placeholder="Button link" />
                  </div>
                </div>
              </template>
              <template v-else>
                <a :href="button.link">{{ button.text }}</a>
              </template>
            </template>
            <div class="clearfix"></div>
            <div class="landing-page-add-section"
                 v-if="pageEditMode"
                 @click.prevent="addSection('contact-cta-button')">+ Add button</div>
          </div>
        </div>
      </div>
    </div>

    <div class="landing-page-change-image" v-if="activePopup && pageEditMode && isGM()">
      <div class="modal-inner" ref="iconPopup">
        <h2>Upload icons for: {{ activePopup.title }}</h2>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="modal-item">
          <h2>Image (normal)</h2>
          <div class="modal-image"
               v-bind:style="{ backgroundImage: getImage(activePopup.image) }">
            <label for="popup-step-image-upload"
                   class="step-item-upload"></label>
            <input type="file"
                   @change="onFileChange($event, activePopup, 'image')"
                   id="popup-step-image-upload" />
          </div>
          <input type="text" v-model="activePopup.altImage" placeholder="Image alt" />
        </div>
        <div class="modal-item">
          <h2>Image (high contrast)</h2>
          <div class="modal-image"
               v-bind:style="{ backgroundImage: getImage(activePopup.imageHigh) }">
            <label for="popup-step-high-image-upload"
                   class="step-item-upload"></label>
            <input type="file"
                   @change="onFileChange($event, activePopup, 'imageHigh')"
                   id="popup-step-high-image-upload" />
          </div>
          <input type="text" v-model="activePopup.altImageHigh" placeholder="High contrast image alt" />
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="sliderModalShown && pageEditMode && isGM()">
      <div class="modal-inner" ref="sliderPopup">
        <h2>Change slider items</h2>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="logos">
          <div class="logo-item" v-for="(item, index) in content.clientSection.logos">
            <div class="modal-item">
              <h2>Image (normal)</h2>
              <div class="modal-image"
                   v-bind:style="{ backgroundImage: getImage(item.image) }">
                <label :for="'logo-normal-' + index"
                       class="step-item-upload"></label>
                <input type="file"
                       @change="onFileChange($event, item, 'image')"
                       :id="'logo-normal-' + index" />
              </div>
              <input type="text" v-model="item.altImage" placeholder="Image alt" />
            </div>
            <div class="modal-item">
              <h2>Image (high contrast)</h2>
              <div class="modal-image"
                   v-bind:style="{ backgroundImage: getImage(item.imageHigh) }">
                <label :for="'logo-high-' + index"
                       class="step-item-upload"></label>
                <input type="file"
                       @change="onFileChange($event, item, 'imageHigh')"
                       :id="'logo-high-' + index" />
              </div>
              <input type="text" v-model="item.altImageHigh" placeholder="High contrast image alt" />
            </div>
            <div class="logo-url">
              <input placeholder="url" v-model="item.url" />
            </div>
            <div class="landing-page-remove"
                 v-if="pageEditMode && isGM()"
                 @click.prevent="removeSection(content.clientSection.logos, index)"></div>
          </div>
          <div class="landing-page-add-section"
               @click.prevent="addSection('logos')"
               v-if="pageEditMode && isGM()">+ Add row</div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h2>Change page meta</h2>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import Slick from 'vue-slick'

  export default {
    name: 'about-page',
    data () {
      return {
        pageEditMode: false,
        landingPanel: false,
        pageMetaEdit: false,
        editHistory: false,
        pageVersions: [],
        metaData: {
          title: '',
          description: ''
        },
        content: {
          title: '',
          description: '',
          heroSection: {
            title: '',
            description: '',
            image: '',
            altImage: '',
            button: {
              text: '',
              url: ''
            },
            hideSection: false
          },
          clientSection: {
            title: '',
            description: '',
            logos: [
              {
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: '',
                url: ''
              }
            ],
            hideSection: false
          },
          howItWorksSection: {
            title: '',
            description: '',
            sections: [
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              },
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              },
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              },
              {
                title: '',
                description: '',
                image: '',
                altImage: '',
                imageHigh: '',
                altImageHigh: ''
              }
            ],
            hideSection: false
          },
          testimonialsSection: {
            title: '',
            testimonials: [
              {
                text: '',
                name: '',
                company: '',
                image: '',
                altImage: ''
              }
            ],
            hideSection: false
          },
          contactCTA: {
            title: '',
            text: '',
            buttons: [
              {
                text: '',
                link: ''
              }
            ],
            hideSection: false
          },
          subscribeSection: {
            title: '',
            description: '',
            formTitle: '',
            hideSection: false
          }
        },
        windowWidth: window.innerWidth,
        serverValidation: {
          errors: []
        },
        disableAPI: false,
        slidesReady: false,
        howItWorksOptionsContent: {
          arrows: false,
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          accessibility: true,
          draggable: true
        },
        testimonialsOptionsContent: {
          arrows: true,
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          accessibility: true,
          draggable: true
        },
        activePopup: null,
        sliderModalShown: false,
        subscribeForm: {
          firstnameFocus: false,
          lastnameFocus: false,
          emailFocus: false,
          firstname: '',
          lastname: '',
          email: ''
        },
        formStatus: {
          shown: false,
          success: false,
          title: '',
          body: '',
          submitting: false
        }
      }
    },
    computed: {
      ...mapGetters([
        'getIsLoggedIn',
        'getUserRole',
        'selectedHightCont',
        'getSelectedFontSize'
      ])
    },
    methods: {
      ...mapActions([
        'redirect',
        'getRoles',
        'setFontSizeActive',
        'setColorPaletteActive'
      ]),
      subscribeMe () {
        this.formStatus.submitting = true
        this.$validator.validateAll([
          'First name',
          'Last name',
          'Email address'
        ]).then((result) => {
          if (!result) {
            this.formStatus.submitting = false
            return
          }
          let firstname = this.subscribeForm.firstname
          let lastname = this.subscribeForm.lastname
          let email = this.subscribeForm.email
          let body = {
            firstname: firstname,
            lastname: lastname
          }
          this.$http.post(api.URLS.subscribe + '/' + email, body, api.headersAuthSettings).then((res) => {
            this.formStatus.submitting = false
            this.formStatus.shown = true
            this.formStatus.success = true
            this.formStatus.title = 'You have been successfully subscribed to the Clear Assured newsletter.'
            this.formStatus.body = 'We will send you news about our latest resources made available on the web app and will keep you updated with our events and webinars. You can always unsubscribe from your email.'
            this.subscribeForm.firstname = ''
            this.subscribeForm.lastname = ''
            this.subscribeForm.email = ''
            setTimeout(() => {
              this.errors.clear()
            }, 100)
          }).catch((err) => {
            this.formStatus.submitting = false
            this.serverValidation.errors = err
            this.disableAPI = false
            this.formStatus.shown = true
            this.formStatus.success = false
            this.formStatus.title = err.body.message || 'Your subscribe request was not submitted.'
            this.formStatus.body = 'It looks like there was an error. Please try again or give us a call and we\'ll have our support team help you.'
          })
        })
      },
      updateLandingPage () {
        if (this.disableAPI) return
        let body = JSON.stringify(this.content)
        let pageData = {
          slug: 'about-us',
          body: body
        }
        this.disableAPI = true
        this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.getLandingPage()
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      updateMeta () {
        if (this.disableAPI) return
        let metaTitle = this.metaData.title
        let metaDescription = this.metaData.description
        let pageData = {
          title: metaTitle,
          slug: 'about-us',
          description: metaDescription
        }
        this.disableAPI = true
        this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          document.location.reload()
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      getLandingPage (id) {
        if (this.disableAPI) return
        this.disableAPI = true
        this.slidesReady = false
        let body = {
          slug: 'about-us'
        }
        if (id) {
          body.id = id
        }
        this.$http.post(api.URLS.staticpage + '/about-us', body, api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          let pageData = JSON.parse(res.data.body)
          this.content = {...this.content, ...pageData}
          this.metaData.title = res.data.title
          this.metaData.description = res.data.description
          if (this.metaData.title && this.metaData.title !== '') {
            document.title = this.metaData.title + ' | Clear Assured'
          }
          this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
          this.content.title = this.metaData.title
          this.content.description = this.metaData.description
          this.slidesReady = true
          this.$nextTick(() => {
            if (this.$refs.testimonialsSlick) {
              this.$refs.testimonialsSlick.reSlick()
            }
            if (this.$refs.howItWorksSlick) {
              this.$refs.howItWorksSlick.reSlick()
            }
          })
          if (id) {
            this.pageEditSwitch()
          } else {
            this.pageEditMode = false
          }
          this.$store.commit('setUserDimensions')
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname])
            window._paq.push(['setDocumentTitle', document.title])
            window._paq.push(['trackPageView'])
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', 'PUBLIC_PAGE')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      getPageVersions () {
        let self = this
        if (this.disableAPI) return
        this.disableAPI = true
        this.$http.get(api.URLS.staticpagechanges + '/about-us', api.headersAuthSettings).then((res) => {
          this.disableAPI = false
          this.pageVersions = []
          for (let index in res.body) {
            self.pageVersions.push({
              label: self.convertDateTime(res.body[index].createdAt),
              id: res.body[index].id
            })
          }
          this.editHistory = true
        }).catch((err) => {
          this.disableAPI = false
          console.log('err', err)
        })
      },
      activateEditHistory () {
        this.getPageVersions()
      },
      getPageVersionsForSelect () {
        return this.pageVersions
      },
      changeLandingPage (el) {
        this.getLandingPage(el.id)
      },
      convertDateTime (payload) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        let hours = date.getHours()
        let minutes = date.getMinutes()
        let ampm = hours >= 12 ? 'PM' : 'AM'
        let newHours = hours % 12 ? hours % 12 : 12
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
        let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
        return dateString + ' ' + timeString
      },
      addPageMeta (name, data) {
        let meta = document.createElement('meta')
        meta.name = name
        for (let index in data) {
          meta.setAttribute(data[index].name, data[index].value)
        }
        document.getElementsByTagName('head')[0].appendChild(meta)
      },
      discardChanges () {
        this.getLandingPage()
      },
      pageEditSwitch () {
        this.pageEditMode = true
        this.$nextTick(() => {
          this.autoSizeOnInit()
        })
      },
      discardPageEdit () {
        this.discardChanges()
        if (this.editHistory) {
          this.editHistory = false
        } else {
          this.landingPanel = false
        }
      },
      addSection (section) {
        if (section === 'testimonials') {
          this.content.testimonialsSection.testimonials.push({
            text: '',
            name: '',
            company: '',
            image: '',
            altImage: ''
          })
        }
        if (section === 'contact-cta-button') {
          this.content.contactCTA.buttons.push({
            text: '',
            link: ''
          })
        }
        if (section === 'features') {
          this.content.featuresSection.items.push({
            title: '',
            text: '',
            video: '',
            button: {
              text: '',
              url: ''
            },
            image: '',
            altImage: ''
          })
        }
        if (section === 'how-it-works') {
          this.content.howItWorksSection.sections.push({
            title: '',
            description: '',
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: ''
          })
          console.log(this.content.howItWorksSection.sections)
        }
        if (section === 'logos') {
          this.content.clientSection.logos.push({
            image: '',
            altImage: '',
            imageHigh: '',
            altImageHigh: '',
            url: ''
          })
        }
      },
      removeSection (section, index) {
        section.splice(index, 1)
      },
      onFileChange (e, target, item) {
        var input = e.target
        let self = this
        if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
          var reader = new FileReader()
          reader.onload = function (e) {
            let fileName = input.files[0].name
            let extension = fileName.split('.').pop().toLowerCase()
            if (self.disableAPI) return
            let pageData = {
              file: e.target.result,
              extension: extension
            }
            self.disableAPI = true
            self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
              self.disableAPI = false
              target[item] = res.body
            }).catch((err) => {
              self.disableAPI = false
              console.log('err', err)
            })
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      getImagePath () {
        return api.serverURL + '/uploads/images/content/'
      },
      isBase64 (payload) {
        return payload.indexOf('data:') !== -1
      },
      getImage (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
      },
      getImageFullPath (payload) {
        if (!payload) {
          return ''
        }
        return this.isBase64(payload) ? payload : this.getImagePath() + payload
      },
      getHighImage (item) {
        return this.selectedHightCont === 1 ? item.imageHigh : item.image
      },
      getHighImageAlt (item) {
        return this.selectedHightCont === 1 ? item.altImageHigh : item.altImage
      },
      activatePopup (item) {
        this.activePopup = item
      },
      closePopup () {
        this.activePopup = null
        this.sliderModalShown = false
        this.slidesReady = true
        this.pageMetaEdit = false
        this.$nextTick(() => {
          if (this.$refs.testimonialsSlick) {
            this.$refs.testimonialsSlick.reSlick()
          }
          if (this.$refs.howItWorksSlick) {
            this.$refs.howItWorksSlick.reSlick()
          }
        })
      },
      closePopupOnOutsideClick (e) {
        let iconPopup = this.$refs.iconPopup
        let sliderPopup = this.$refs.sliderPopup
        let target = e.target
        if (iconPopup && iconPopup !== target && !iconPopup.contains(target)) {
          this.activePopup = null
        }
        if (sliderPopup && sliderPopup !== target && !sliderPopup.contains(target)) {
          this.switchSliderModal()
          this.slidesReady = true
          this.$nextTick(() => {
            if (this.$refs.testimonialsSlick) {
              this.$refs.testimonialsSlick.reSlick()
            }
            if (this.$refs.howItWorksSlick) {
              this.$refs.howItWorksSlick.reSlick()
            }
          })
        }
      },
      getVideoUrl (url) {
        let link = url
        if (url !== '') {
          let linkPart = url.split('/')
          if (linkPart) {
            if (linkPart[2].indexOf('youtu') !== -1) {
              link = `${linkPart[0]}//www.youtube.com/embed/${linkPart[linkPart.length - 1]}`
            }
            if (linkPart[2].indexOf('vimeo') !== -1) {
              link = `${linkPart[0]}//player.vimeo.com/video/${linkPart[linkPart.length - 1]}`
            }
            link += '?autoplay=0&loop=1'
          }
        }
        return link
      },
      switchSliderModal () {
        this.sliderModalShown = !this.sliderModalShown
      },
      autoSize (el) {
        setTimeout(function () {
          el.target.style = 'height:auto; padding:0'
          el.target.style = 'height:' + el.target.scrollHeight + 'px'
        }, 0)
      },
      autoSizeOnInit () {
        let textAreas = document.getElementsByTagName('textarea')
        for (let i = 0; i < textAreas.length; i++) {
          let item = textAreas[i]
          setTimeout(function () {
            item.style = 'height:auto; padding:0'
            item.style = 'height:' + item.scrollHeight + 'px'
          }, 0)
        }
      },
      isGM () {
        let isLogged = this.getIsLoggedIn
        if (!isLogged) {
          return false
        }
        let userRole = this.getUserRole
        if (userRole === 'gm') {
          return true
        }
        return false
      },
      handleWindowResize (event) {
        this.windowWidth = event.currentTarget.innerWidth
      },
      getDeviceType (check) {
        let width = this.windowWidth
        let deviceName = ''
        if (width > 1024) {
          deviceName = 'desktop'
        } else if (width > 640) {
          deviceName = 'tablet'
        } else {
          deviceName = 'mobile'
        }
        return check === deviceName
      }
    },
    beforeMount () {
      this.getLandingPage()
    },
    mounted () {
      this.setFontSizeActive()
      this.setColorPaletteActive()
      window.addEventListener('resize', this.handleWindowResize)
      document.addEventListener('click', this.closePopupOnOutsideClick)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleWindowResize)
      document.addEventListener('click', this.closePopupOnOutsideClick)
    },
    components: {
      Slick
    },
    watch: {}
  }
</script>

<style src="@/assets/scss/main/homepage.scss" lang="scss" scoped></style>
<style src="@/assets/scss/components/slick.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// About.vue?0277bf81